import { EVENTURL } from "helpers/constant";
import { callApi } from "Apis";

export async function eventList(data) {
  try {
    const response = await callApi({ url: EVENTURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function eventAdd(data) {
  try {
    const response = await callApi({ url: EVENTURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getEventById(id) {
  try {
    const response = await callApi({ url: EVENTURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
export async function updateEvent(data) {
  try {
    const response = await callApi({ url: EVENTURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteEventById(id) {
  try {
    const response = await callApi({ url: EVENTURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}
